import MenuMobile from "./components/mobile-navigation";
import Home from "./pages/Home";
import { NavBar } from "./sections/navbar";
import { Suspense } from "react";
import Loading from "./pages/Loading";
import About from "./pages/About";
import ContactPage from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <NavBar />
      <MenuMobile />
      <div className="main">
        <div className="container" id="Home">
          <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        </div>
        <div className="container" id="About">
          <About />
        </div>
        <div className="container" id="Contact">
          <ContactPage />
        </div>
        <footer className="footer container">
          <div>
            Copyright &copy; {new Date().getFullYear()}
            <br />
            Made with ❤️ by Sahul
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
